import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as styles from './NewPartnerTotals.scss';

var NewPartnerTotals = /*#__PURE__*/function (_Component) {
  _inherits(NewPartnerTotals, _Component);

  var _super = _createSuper(NewPartnerTotals);

  function NewPartnerTotals() {
    var _this;

    _classCallCheck(this, NewPartnerTotals);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "defaultProps", {
      textStyle: {},
      style: {},
      partnerType: null,
      isMultilocationContract: false,
      isAffiliateContract: false
    });

    _defineProperty(_assertThisInitialized(_this), "formatDollars", function (num) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(num).replace('$', '');
    });

    return _this;
  }

  _createClass(NewPartnerTotals, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formValues = _this$props.formValues,
          textStyle = _this$props.textStyle;
      var initialTeamMembers = formValues.initialTeamMembers,
          initialTeamMembersMonthlyPrice = formValues.initialTeamMembersMonthlyPrice,
          additionalTeamMembersMonthlyPrice = formValues.additionalTeamMembersMonthlyPrice,
          initialClients = formValues.initialClients,
          initialClientsMonthlyPrice = formValues.initialClientsMonthlyPrice,
          llManagedMonthlyFee = formValues.llManagedMonthlyFee,
          partnerManagedMonthlyFee = formValues.partnerManagedMonthlyFee;

      if (!initialTeamMembers || isNaN(initialTeamMembers)) {
        initialTeamMembers = 0;
      }

      if (!initialTeamMembersMonthlyPrice || isNaN(initialTeamMembersMonthlyPrice)) {
        initialTeamMembersMonthlyPrice = 0;
      }

      if (!initialClients || isNaN(initialClients)) {
        initialClients = 0;
      }

      if (!initialClientsMonthlyPrice || isNaN(initialClientsMonthlyPrice)) {
        initialClientsMonthlyPrice = 0;
      }

      var initialTeamMemberCost = parseInt(initialTeamMembers) * parseInt(initialTeamMembersMonthlyPrice);
      var initialClientCost = parseInt(initialClients) * parseInt(initialClientsMonthlyPrice);
      var totalDueToday = initialTeamMemberCost + initialClientCost + parseInt(formValues.monthlyFee);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.item
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: textStyle
      }, "Monthly Fee"), /*#__PURE__*/React.createElement("span", {
        className: styles.value,
        style: textStyle
      }, "$", this.formatDollars(formValues.monthlyFee))), /*#__PURE__*/React.createElement("div", {
        className: styles.item
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: textStyle
      }, parseInt(initialTeamMembers) + 1, " Initial Team Members"), /*#__PURE__*/React.createElement("span", {
        className: styles.value,
        style: textStyle
      }, "$", this.formatDollars(initialTeamMemberCost)), /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, "1 Free Team Member"), /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, initialTeamMembers, " Team Members @ $", initialTeamMembersMonthlyPrice, "/mo"), /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, "Additional Team Members added later will cost $", additionalTeamMembersMonthlyPrice, "/mo")), /*#__PURE__*/React.createElement("div", {
        className: styles.item
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: textStyle
      }, "1 Initial Admin Account"), /*#__PURE__*/React.createElement("span", {
        className: styles.value,
        style: textStyle
      }, "$0.00"), /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, "1 Partner Account Included"), /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, "Partner account can include posting to Facebook, Twitter and LinkedIn for partner's social media accounts.")), !this.props.isAffiliateContract && /*#__PURE__*/React.createElement("div", {
        className: styles.item
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: textStyle
      }, parseInt(initialClients), " Initial ", this.props.isMultilocationContract ? 'Locations' : 'Clients'), /*#__PURE__*/React.createElement("span", {
        className: styles.value,
        style: textStyle
      }, "$", this.formatDollars(initialClientCost)), parseInt(initialClients, 10) > 0 && /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, initialClients, " ", this.props.isMultilocationContract ? 'Locations' : 'Clients', " @ $", initialClientsMonthlyPrice, "/mo"), !this.props.isMultilocationContract && /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, "Additional Partner-managed clients added later will cost $", partnerManagedMonthlyFee, "/mo"), !this.props.isMultilocationContract && /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, "Additional Likeable Local-managed clients added later will cost $", llManagedMonthlyFee, "/mo"), this.props.isMultilocationContract && /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint,
        style: textStyle
      }, "Additional locations added later will cost $", llManagedMonthlyFee, "/mo")), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.item, " ").concat(styles.totalItem)
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: textStyle
      }, "Total Due Today"), /*#__PURE__*/React.createElement("span", {
        className: styles.value,
        style: textStyle
      }, "$", this.formatDollars(totalDueToday))));
    }
  }]);

  return NewPartnerTotals;
}(Component);

export default NewPartnerTotals;